// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2xptZ","signatureBlock":"Footer_signatureBlock__2Tyn8","signature":"Footer_signature__MYDUj"};